/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { TaxIdMappingRule } from '../../models/tax-id-mapping-rule';

export interface TaxIdMappingRulesIdGet$Params {
  id: string;
  'Active-Tenant-Identifier': string;
}

export function taxIdMappingRulesIdGet(http: HttpClient, rootUrl: string, params: TaxIdMappingRulesIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & TaxIdMappingRule>> {
  const rb = new RequestBuilder(rootUrl, taxIdMappingRulesIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      } & TaxIdMappingRule>;
    })
  );
}

taxIdMappingRulesIdGet.PATH = '/tax-id-mapping-rules/{id}';
